import { useIntl } from 'react-intl';

/**
 * App-wide banner shown above the entire layout when the active workspace is
 * flagged as a non-production testing environment (`workspaces.is_test`). Kept
 * deliberately loud (solid yellow, full width) so a tester never mistakes a
 * test workspace for production. The workspace name is rendered bold via the
 * message's `<name>` chunk.
 */
export function TestWorkspaceBanner({ workspaceName }: { readonly workspaceName: string }) {
  const intl = useIntl();

  return (
    <div role="status" className="bg-warning-200 px-6 py-3 text-center text-sm font-medium text-warning-700">
      {intl.formatMessage(
        { id: 'pages.shell.test-banner.message' },
        { workspaceName, name: (chunks) => <strong className="font-semibold">{chunks}</strong> },
      )}
    </div>
  );
}
